module.exports = __webpack_public_path__ + "media/images/lb/876-44890379be09d39a671a2efdb1abd1f9.svg";